<template lang="pug">
  div.sc-profile
    ods-row(type='flex', justify='center', align='middle')
      ods-col.sc-profile__inner(:xs='{ span:24 }', :sm='{ span: 20 }', :md='{ span: 16 }', :xl='{ span: 12 }', type='flex')
        ods-row(type='flex')
          ods-col
            ods-row(type='flex', justify='end')
              ods-col(:sm= ' { span: 12 }')
                ods-button.sc-profile__change-password(@click.native='toggleChangePasswordModal', type='text', icon='ods-icon-lock', small) cambiar contraseña
          ods-col.sc-profile__left(:xs='{ span: 24 }', :sm='{ span: 8 }', type='flex', justify='center', align='middle')
            div.sc-profile__photo-wrap
              ods-button(circle, icon='ods-icon-edit', size='small')
          ods-col.sc-profile__right(:sm=' { span: 16 }')
            ods-row
              ods-col
                ods-form(ref='profileForm')
                  ods-form-item.sc-profile__name-wrap(label='id de usuario')
                    ods-input(type='text' value="Smartcities")
                  ods-row.sc-profile__multi-field(type='flex', justify='space-between')
                    ods-form-item(label='nombre')
                      ods-input.new-input(type='text' value="citylandscapemanager")
                    ods-form-item(label='apellido')
                      ods-input(type='text' value='citylandscapemanager')
                  ods-row.sc-profile__multi-field(type='flex', justify='space-between')
                    ods-form-item(label='telefono')
                      ods-input(type='text' value="+34")
                    ods-form-item(label='email')
                      ods-input(type='email' value="soporte@smartcities.com")
                  ods-form-item(label='idioma de interfaz')
                    ods-input(type='text' value="Español")
                  ods-form-item.sc-profile__btn-wrap
                    ods-button(icon='ods-icon-edit') Editar
    ods-dialog(
      @close='resetForm("newPasswordForm")'
      :visible.sync='changePasswordModalOpen'
      width='95%'
      :append-to-body='false'
      custom-class='sc-modal'
    )
      span.sc-modal__title Cambiar contraseña
      p.sc-modal__desc La contraseña debe tener un mínimo de 6 caracteres y contener letras y números.
      ods-form(:model='newPasswordForm' :rules='rules' ref='newPasswordForm')
        ods-form-item(label='nueva contraseña' prop='firstPassword')
          ods-input(type='password' v-model='newPasswordForm.firstPassword' auto-complete='off')
        ods-form-item(label='repetir contraseña' prop='secondPassword')
          ods-input(type='password' v-model='newPasswordForm.secondPassword' auto-complete='off')
        ods-button(@click.native='toggleChangePasswordModal', type='text') cancelar
        ods-button(type='primary', @click.prevent='submitForm("newPasswordForm")') cambiar
</template>

<script>
export default {
  name: 'Profile',
  data () {
    const validateFirstPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Por favor rellena el campo'))
      } else {
        if (this.newPasswordForm.secondPassword !== '') {
          this.$refs.newPasswordForm.validateField('secondPassword')
        }
        callback()
      }
    }
    const validateSecondPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Por favor rellena el campo'))
      } else if (value !== this.newPasswordForm.firstPassword) {
        callback(new Error('Los campos no coinciden'))
      } else {
        callback()
      }
    }
    return {
      changePasswordModalOpen: false,
      newPasswordForm: {
        firstPassword: '',
        secondPassword: ''
      },
      rules: {
        firstPassword: [
          { validator: validateFirstPass, trigger: 'blur' }
        ],
        secondPassword: [
          { validator: validateSecondPassword, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    toggleChangePasswordModal () {
      this.changePasswordModalOpen = this.changePasswordModalOpen === false
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log('valid')
        } else {
          console.log('no valid')
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  }
}

</script>

<style lang="scss" scoped>

.sc-profile {
  &__inner {
    background: $--color-white;
    box-shadow: 0 2px 10px 0 rgba(0,0,0,0.05);
    height: auto;
    margin-top: rem(64);
    position: relative;
    max-width: $max-width;

    /deep/ .ods-form {
      padding: 0 20px;
      @media (min-width: $--sm) {
        padding: 0 rem(64) rem(32) 0;
      }
    }

    /deep/ .ods-form-item {
      margin-bottom: rem(16);
    }

    /deep/ .ods-input__inner {
      border-bottom: 0;
      background: $--color-grey-light;
    }

    > .ods-row, > .ods-col {
      height: 100%;
    }

    @media (min-width: $--sm) {
      .ods-form-item {
        width: 45%;
      }
    }
  }

  &__left {
    height: 100%;
  }

  /deep/ .sc-profile__name-wrap input {
    font-size: rem(18);
    font-weight: 500;
    height: rem(40);
  }

  &__change-password {
    float: right;
    padding: rem(24) rem(32) rem(5) rem(40);
  }

  &__photo-wrap {
    background-image: url(https://www.creartuavatar.com/images/m7.svg);
    background-size: cover;
    background-repeat: no-repeat;
    border-radius: 50%;
    height: rem(96);
    width: rem(96);
    margin-top: rem(16);
    position: relative;

    /deep/ {
      .ods-button {
        position: absolute;
        bottom: 0;
        right: rem(-16);
        i {
          height: rem(32);
          width: rem(32);
          font-size: rem(16);
        }
      }
    }
  }

  &__change-password {
    /deep/ i {
      font-size: rem(16);
    }
  }

  &__btn-wrap {
    text-align: center;
    margin-top: rem(32);

    /deep/ i {
      font-size: rem(20);
      margin-right: rem(5);
    }
    @media (min-width: $--sm) {
      margin-top: 0;
      position: absolute;
      bottom: -6.99rem;
      right: 0;

      /deep/ .ods-button {
        float: right;
      }
    }
  }

  &__multi-field {
    flex-direction: column;

    @media (min-width: $--sm) {
      flex-direction: row;
    }
  }

  /deep/ {
    .sc-modal {
      min-height: rem(464);
      max-width: rem(384);
      margin: auto;

      &__header {
        padding: 0;
      }

      &__body {
        padding: rem(40);
      }

      &__title {
        display: inline-block;
        margin: rem(-10) 0 rem(10);
      }

      &__desc {
        font-size: rem(12);
        line-height: rem(24);
        margin-bottom: rem(32);
      }
    }

    .ods-dialog__headerbtn {
      top: rem(24);
      right: rem(24);
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/Profile.vue